export const SET_PYQ_TESTS_DATA = "SET_PYQ_TESTS_DATA";
export const SET_PYQ_TESTS_RESULT_DATA = "SET_PYQ_TESTS_RESULT_DATA";
export const SET_PYQ_JEE_MAINS_OR_ADVANCED = "SET_PYQ_JEE_MAINS_OR_ADVANCED"
